var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: _vm.modalBodyID,
      attrs: {
        "body-class": "vue-generic-modal",
        "hide-footer": "",
        "hide-header": "",
        size: _vm.modalSize
      }
    },
    [_c("div", { attrs: { id: _vm.modalBodyID } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }